import { useDashQuery, useLazyDashQuery, useDashMutation } from './clientHooks'

// Re-Export Base Apollo React Hooks
export * from '@apollo/client'

export const useQuery = useDashQuery
export const useLazyQuery = useLazyDashQuery
export const useMutation = useDashMutation
